import { memo, useMemo } from 'react';
import { generatePath } from 'react-router-dom';

import { Paths } from '../../../app/constants/paths';
import { useTenant } from '../../../app/context/tenant-context';
import { useTabManager } from '../../context/tab-manager-context';
import { ExportCollectionModal } from '../export-modal/export-modal';

import { Modal, ModalHeader, ModalBody, ModalFooter } from '@controlrooms/components';

export const ShareCollectionLinkModal = memo(({ onClose }: { onClose: () => void }) => {
  const { viewCollection } = useTabManager();
  const { tenant } = useTenant();

  const viewLink = useMemo(
    () =>
      `${window.location.origin}${generatePath(Paths.COLLECTION_SHARE, {
        tenantId: tenant.toString(),
        hash: viewCollection.collectionId,
      })}`,
    [tenant, viewCollection.collectionId],
  );

  return (
    <Modal open={true} onCancel={onClose} size="sm">
      <ModalHeader title="Share Collection" />
      <ModalBody>
        <ExportCollectionModal link={viewLink} hash={viewCollection.collectionId as string} />
      </ModalBody>
      <ModalFooter
        confirmText="Close"
        onConfirm={onClose}
        cancelTestId="modal-close-icon-delete-alert"
      />
    </Modal>
  );
});
